import { useQuery } from "@tanstack/react-query";
import { fetchResourceById } from "../../utils/api";
import { DEFAULT_QUERY_CONFIG } from "./config/queryConfig";

export const useResourceById = <T>(resource: string, id: string) => {
    return useQuery<T>({
        queryKey: [resource, id],
        queryFn: () => fetchResourceById(resource, id),
        enabled: !!id,
        staleTime: DEFAULT_QUERY_CONFIG.STALE_TIME,
    });
};
